import { RelatorioPrestacaoContasForm } from "../typings";
import { showErrorAxios } from 'infra/helpers/alerta';
import { useState } from 'react';
import { useCallback } from 'react';
import http from 'infra/http';

function useRelatorioPrestacaoContasDetalhe() {
  const [isLoading, setIsLoading] = useState(false);


  const getData = useCallback(async (relatorioPrestacaoContasId: string) => {
    try {
      setIsLoading(true);

      const {data} = await http.get<RelatorioPrestacaoContasForm>(`/v1/relatorios/financeiro/prestacao-contas/${relatorioPrestacaoContasId}`)

      return data;
    } catch (err) {
      showErrorAxios(err);
    } finally {
      setIsLoading(false);
    }
  }, [])
  
  return {
    isLoading,
    getData,
  }
}

export default useRelatorioPrestacaoContasDetalhe;
